import { toDisplayString as _toDisplayString, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"
import _imports_0 from '@/app/ui/assets/svg/delete.svg'


const _hoisted_1 = { class: "border border-gray-lp-1400 rounded-md" }
const _hoisted_2 = { class: "text-left p-4 w-1/6" }
const _hoisted_3 = { class: "text-left p-4 w-1/2" }
const _hoisted_4 = { class: "text-left p-4 w-1/4" }
const _hoisted_5 = { class: "w-1/6 px-4" }
const _hoisted_6 = { class: "w-1/2 px-4" }
const _hoisted_7 = { class: "w-1/4 px-4" }
const _hoisted_8 = { class: "flex items-center gap-2 w-full" }
const _hoisted_9 = { class: "border-t border-gray-lp-1400" }
const _hoisted_10 = { colspan: 3 }
const _hoisted_11 = { class: "gap-x-2 justify-center items-center flex" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SelectSearch = _resolveComponent("SelectSearch")!
  const _component_lp_input = _resolveComponent("lp-input")!
  const _component_Icons = _resolveComponent("Icons")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("table", null, [
      _createVNode("thead", null, [
        _createVNode("th", _hoisted_2, _toDisplayString(_ctx.$t("clientManagement.discountProduct.no")), 1),
        _createVNode("th", _hoisted_3, _toDisplayString(_ctx.$t("clientManagement.discountProduct.shippingType")), 1),
        _createVNode("th", _hoisted_4, _toDisplayString(_ctx.$t("clientManagement.discountProduct.percentage")), 1)
      ]),
      _createVNode("tbody", null, [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.productDiscount, (item, idx) => {
          return (_openBlock(), _createBlock("tr", {
            class: "border-t border-gray-lp-1400 my-3",
            key: idx
          }, [
            _createVNode("td", _hoisted_5, _toDisplayString(idx + 1), 1),
            _createVNode("td", _hoisted_6, [
              _createVNode(_component_SelectSearch, {
                modelValue: _ctx.productDiscount[idx].product,
                "onUpdate:modelValue": ($event: any) => (_ctx.productDiscount[idx].product = $event),
                placeholder: _ctx.$t('clientManagement.discountProduct.selectShippingType'),
                isLoading: _ctx.isLoadingProduct,
                options: _ctx.getFilteredProducts(idx),
                onFocus: _ctx.fetchProduct,
                onBlur: _ctx.onBlur,
                onFilter: _ctx.fetchProduct,
                onChange: _ctx.updateValue,
                keyName: "name",
                keyValue: "id",
                isDisabled: _ctx.isDisabled,
                disabledBackground: _ctx.isDisabled
              }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder", "isLoading", "options", "onFocus", "onBlur", "onFilter", "onChange", "isDisabled", "disabledBackground"])
            ]),
            _createVNode("td", _hoisted_7, [
              _createVNode("div", _hoisted_8, [
                _createVNode(_component_lp_input, {
                  format: _ctx.formatFloat,
                  modelValue: _ctx.productDiscount[idx].discount,
                  "onUpdate:modelValue": ($event: any) => (_ctx.productDiscount[idx].discount = $event),
                  error: Number(_ctx.productDiscount[idx].discount) > 30,
                  onChange: _ctx.updateDiscount,
                  errorCaption: _ctx.$t('clientManagement.discountProduct.discountRangeError'),
                  placeholder: "0",
                  min: "0",
                  max: "100",
                  suffix: "%",
                  disabled: _ctx.isDisabled
                }, null, 8, ["format", "modelValue", "onUpdate:modelValue", "error", "onChange", "errorCaption", "disabled"]),
                (!_ctx.isDisabled && _ctx.productDiscount.length > 1)
                  ? (_openBlock(), _createBlock("img", {
                      key: 0,
                      src: _imports_0,
                      alt: "",
                      class: "cursor-pointer",
                      onClick: ($event: any) => (_ctx.deleteProductDiscount(idx))
                    }, null, 8, ["onClick"]))
                  : _createCommentVNode("", true)
              ])
            ])
          ]))
        }), 128)),
        _createVNode("tr", _hoisted_9, [
          _createVNode("td", _hoisted_10, [
            _createVNode("button", {
              style: {"border-color":"#d4d5d8"},
              class: 
                `py-2 px-3 font-semibold ${
                  _ctx.isDisabled || _ctx.disabledAddProductDiscount
                    ? 'text-gray-lp-600'
                    : 'text-red-lp-100 cursor-pointer'
                }`
              ,
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.addProductDiscount && _ctx.addProductDiscount(...args))),
              disabled: _ctx.isDisabled || _ctx.disabledAddProductDiscount
            }, [
              _createVNode("span", _hoisted_11, [
                _createVNode(_component_Icons, {
                  name: "plus-circle",
                  class: `${_ctx.isDisabled || _ctx.disabledAddProductDiscount ? 'text-gray-lp-600' : 'text-red-lp-100'}`
                }, null, 8, ["class"]),
                _createTextVNode(" " + _toDisplayString(_ctx.$t("clientManagement.discountProduct.addDiscount")), 1)
              ])
            ], 10, ["disabled"])
          ])
        ])
      ])
    ])
  ]))
}